import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import Chip from "@material-ui/core/Chip";
import MagnifyingGlassIcon from "@material-ui/icons/Search";
import IconButton from "@material-ui/core/IconButton";
import { defaultSearchFilter } from "../../utils/constants";
import handleRenderOption from "./SearchResult/handleRenderOption";

function FaqSearchBar({
  faqs,
  searchInFaqs,
  top5Themes,
  searchValue,
  setSearchValue,
  setDetailedFaq,
  setNavigationStatus,
  setSelectedSearchTab,
}) {
  const [openCompletion, setOpenCompletion] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState("");

  let REQuery = {
    query: {
      bool: {
        should: [
          {
            multi_match: {
              query: "carmine",
              fuzziness: "auto",
              fields: [
                "domanda",
                "risposta",
                "keyword^2",
                "vertical",
                "macrotema",
                "tema",
              ],
              operator: "and",
            },
          },
          {
            multi_match: {
              query: "carmine",
              fields: [
                "domanda",
                "risposta",
                "keyword^2",
                "vertical",
                "macrotema",
                "tema",
              ],
              slop: 2,
              type: "phrase",
            },
          },
          {
            multi_match: {
              query: "carmine",
              fuzziness: "auto",
              fields: [
                "domanda",
                "risposta",
                "keyword^2",
                "vertical",
                "macrotema",
                "tema",
              ],
              operator: "or",
            },
          },
          {
            rank_feature: {
              field: "positive_feedback",
              boost: 10000,
              saturation: {
                pivot: 10000,
              },
            },
          },
          {
            rank_feature: {
              field: "negative_feedback",
              boost: 75,
              saturation: {
                pivot: 100,
              },
            },
          },
          {
            rank_feature: {
              field: "views",
              boost: 10000,
              saturation: {
                pivot: 10000,
              },
            },
          },
        ],
        minimum_should_match: 5,
      },
    },
  };

  const showChip = (value) => {
    return (
      <Chip
        key={value.tema + "searchChip"}
        onClick={() => {
          handleChipClick(value.tema);
        }}
        label={value.tema}
      />
    );
  };

  const handleChipClick = (chipText) => {
    setSearchInputValue(
      searchInputValue ? searchInputValue.concat(" " + chipText) : chipText
    );
    // searchInFaqs(chipText, REQuery)
  };

  const _filterOptions = (options, state) => {
    const { inputValue } = state;
    return options
      .map((option) => {
        let nMatches = 0;
        inputValue.split(" ").forEach((w) => {
          if (
            w.length > 2 &&
            (" ".concat(option).toLowerCase().includes(` ${w.toLowerCase()}`) ||
              option.toLowerCase().includes(`'${w.toLowerCase()}`))
          ) {
            nMatches += 1;
          }
        });
        return { option: option, nMatches: nMatches };
      })
      .filter((i) => i.nMatches > 0)
      .sort((a, b) => {
        return b.nMatches - a.nMatches;
      })
      .map((i) => i.option);
  };

  return (
    <>
      <div>
        <Autocomplete
          classes={{ "MuiFormControl-root": "" }}
          freeSolo
          className=""
          disableClearable
          id="faqs_search_bar"
          value={searchValue}
          inputValue={searchInputValue}
          filterOptions={_filterOptions}
          options={faqs.map((faq) => faq._source.domanda)}
          open={openCompletion}
          onInputChange={(event, newInputValue) => {
            setSearchInputValue(newInputValue);
            if (newInputValue === "") {
              setSearchValue("");
            }
            if (newInputValue.length >= 3) {
              setOpenCompletion(true);
            } else {
              setOpenCompletion(false);
            }
          }}
          onChange={(e, v) => {
            const result = faqs.filter((obj) => obj._source.domanda === v);
            if (result.length > 0) {
              setDetailedFaq(result[0]);
              setNavigationStatus("faq_detail");
            } else {
              setSearchValue(v);
              setOpenCompletion(false);
              searchInFaqs(searchInputValue, REQuery);
            }
            setSelectedSearchTab(defaultSearchFilter);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Cerca..."
              margin="normal"
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                type: "search",
                endAdornment: (
                  <React.Fragment>
                    <IconButton
                      style={{ padding: 3, marginLeft: 15 }}
                      onClick={() => searchInFaqs(searchInputValue, REQuery)}
                    >
                      <MagnifyingGlassIcon />
                    </IconButton>
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
          renderOption={handleRenderOption}
        />
      </div>
      {top5Themes &&
        Object.values(top5Themes).map((value) => {
          return showChip(value);
        })}
    </>
  );
}

export default FaqSearchBar;
